import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import ProfileEditService from 'app/admin/profile/service/ProfileEditService';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import ProfileStatusType from '../dto/ProfileStatusType';
import CaptchaTypeEditService from '../../captchatype/service/CaptchaTypeEditService';
//import EditFormRegistrationStatusField from 'modules/ui/editform/fields/EditFormRegistrationStatusField';

const config = {
	key: 'profileEditForm',
	text: 'Profile',
	textKey: 'profile',
	service: ProfileEditService,
	icon: 'person',
	fields: [
		{
			key: 'name',
			text: 'Name',
			textKey: 'name',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'magic',
			text: 'Magic',
			textKey: 'magic',
			component: EditFormTextField,
			required: true,
			readOnly:true
		},
		{
			key: 'status',
			text: 'Status',
			textKey: 'status',
			component: EditFormSelectField,
			type: 'enum',
			readOnly:true,
			items: Object.keys(ProfileStatusType).map(d => {
				return { value: d, label: ProfileStatusType[d] };
			})
		},
		{
			key: 'visualCaptchaType',
			text: 'Visual Captcha Type',
			textKey: 'visualCaptchaType',
			component: EditFormSelectField,
			required: true,
			items: () => CaptchaTypeEditService.getCaptchaTypeSelection()
		},
		{
			key: 'audioCaptchaType',
			text: 'Audio Captcha Type',
			textKey: 'audioCaptchaType',
			component: EditFormSelectField,
			required: true,
			items: () => CaptchaTypeEditService.getCaptchaTypeSelection()
		}
	]
};

function ProfileEditForm() {
	return <EditFormPage config={config} />;
}

export default ProfileEditForm;
